import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectOption } from '../../models/SelectOption';

import './input.scss';
import './Select.scss';

interface Props {
  label?: string;
  placeholder?: string;
  options: SelectOption[];
  value: string;
  disabled?: boolean;
  isValid?: boolean;
  onChange: (value: string) => void;
}

const Select: FC<Props> = ({
  options = [],
  label = undefined,
  placeholder,
  value,
  disabled = false,
  isValid = true,
  onChange,
}) => {
  const { t } = useTranslation();

  const renderOption = option => {
    let label = t(option.label);
    if (!label || label.startsWith('[[')) {
      label = option.label;
    }

    return <option key={option.value} value={option.value} label={label} />;
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`input-container select ${!isValid ? 'input-invalid' : ''}`}>
      {!!label && <p className={disabled ? 'disabled' : ''}>{t(label)}</p>}
      <select onChange={handleChange} disabled={disabled} className={disabled ? 'disabled' : ''} value={value}>
        {placeholder && <option value=''>{t(placeholder)}</option>}
        {options.map(renderOption)}
      </select>
    </div>
  );
};

export default Select;
